<template>
    <transition name="slide">
        <div v-if="showMobileMenu">
            <div class="cd-overlay"></div>
            <div class="cd-nav">
                <ul id="cd-primary-nav" class="cd-primary-nav is-fixed">
                    <li><a href="/">Home</a></li>

                    <li class="has-children">
                        <a
                            href="#"
                            v-on:click="subCruisesShow = !subCruisesShow"
                            >Cruises</a
                        >

                        <ul v-if="subCruisesShow">
                            <li
                                class="go-back"
                                v-on:click="subCruisesShow = !subCruisesShow"
                            >
                                <a href="#0">Terug</a>
                            </li>
                            <li class="">
                                <a href="/aanbiedingen">Aanbiedingen</a>
                            </li>
                            <li class="">
                                <a href="/last-minute-cruises"
                                    >Last Minute Cruises</a
                                >
                            </li>
                            <li style="display: none;">
                                <a href="#">All Inclusive Cruises</a>
                            </li>
                            <li style="display: none;">
                                <a href="#">Cruise only</a>
                            </li>
                            <!-- <li class=""><a href="/cruise-met-vlucht">Cruise + Fly</a></li> -->
                            <li class="">
                                <a href="/goedkope-cruises">Goedkope Cruises</a>
                            </li>
                            <li style="display: none;">
                                <a href="#">Honeymoon Cruises</a>
                            </li>
                            <!--
                            <li style="display: none;">
                                <a href="#">Familie cruises</a>
                            </li>
                            -->
                            <li class="">
                                <a href="/mini-cruises">Minicruises</a>
                            </li>
                            <li class="">
                                <a href="/bestemming/wereldcruise-grandvoyages"
                                    >Grand Voyages &amp; Wereldcruises</a
                                >
                            </li>
                            <li class="">
                                <a href="/cruises-vanuit-nederland"
                                    >Cruises vanuit Nederland</a
                                >
                            </li>

                            <li>
                                <a href="/familie-cruises">Familiecruises</a>
                            </li>
                            <li>
                                <a href="/luxe-cruises">Luxe cruises</a>
                            </li>
                            <li>
                                <a href="/expeditie-cruises"
                                    >Expeditiecruises</a
                                >
                            </li>
                            <li class="">
                                <a href="/nieuwe-schepen-cruises"
                                    >Nieuwe cruise schepen</a
                                >
                            </li>
                        </ul>
                    </li>

                    <li class="has-children">
                        <a
                            href="#"
                            v-on:click="subRederijShow = !subRederijShow"
                            >Rederijen</a
                        >

                        <ul v-if="subRederijShow">
                            <li
                                class="go-back"
                                v-on:click="subRederijShow = !subRederijShow"
                            >
                                <a href="#0">Terug</a>
                            </li>
                            <li class="">
                                <a href="/aida-cruises">AIDA Cruises</a>
                            </li>
                            <li class="">
                                <a href="/azamara-cruises"
                                    >Azamara</a
                                >
                            </li>
                            <li class="">
                                <a href="/carnival-cruises"
                                    >Carnival Cruise Lines</a
                                >
                            </li>
                            <li class="">
                                <a href="/celebrity-cruises"
                                    >Celebrity Cruises</a
                                >
                            </li>
                            <li class="">
                                <a href="/costa-cruises">Costa Cruises</a>
                            </li>
                            <li class="">
                                <a href="/crystal-cruises">Crystal Cruises</a>
                            </li>
                            <li class="">
                                <a href="/disney-cruises">Disney Cruise Line</a>
                            </li>
                            <li class="">
                                <a href="/hapag-lloyd-cruises"
                                    >Hapag-Lloyd Cruises</a
                                >
                            </li>
                            <li class="">
                                <a href="/holland-america-line-cruises"
                                    >Holland America Line</a
                                >
                            </li>
                            <li class="">
                                <a href="/msc-cruises">MSC Cruises</a>
                            </li>
                            <li class="">
                                <a href="/norwegian-cruise-line-cruises"
                                    >Norwegian Cruise Line</a
                                >
                            </li>
                            <li class="">
                                <a href="/oceania-cruises">Oceania Cruises</a>
                            </li>
                            <li class="">
                                <a href="/ponant-cruises">PONANT</a>
                            </li>
                            <li class="">
                                <a href="/princess-cruises">Princess Cruises</a>
                            </li>
                            <li class="">
                                <a href="/regent-seven-seas-cruises"
                                    >Regent Seven Seas Cruises</a
                                >
                            </li>
                            <li class="">
                                <a href="/royal-caribbean-cruises"
                                    >Royal Caribbean</a
                                >
                            </li>
                            <li class="">
                                <a href="/seabourn-cruises">Seabourn</a>
                            </li>
                            <li class="">
                                <a href="/seadream-cruises"
                                    >SeaDream Yacht Club</a
                                >
                            </li>
                            <li class="">
                                <a href="/silversea-cruises"
                                    >Silversea Cruises</a
                                >
                            </li>
                            <li class="">
                                <a href="/star-clippers-cruises"
                                    >Star Clippers</a
                                >
                            </li>
                        </ul>
                    </li>

                    <li class="has-children">
                        <a
                            href="#"
                            v-on:click="subBestemmingShow = !subBestemmingShow"
                            >Bestemmingen</a
                        >

                        <ul v-if="subBestemmingShow">
                            <li
                                class="go-back"
                                v-on:click="
                                    subBestemmingShow = !subBestemmingShow
                                "
                            >
                                <a href="#0">Terug</a>
                            </li>
                            <li class="">
                                <a href="/afrika-cruises">Afrika</a>
                            </li>
                            <li class="">
                                <a href="/alaska-cruises">Alaska</a>
                            </li>
                            <li class="">
                                <a href="/azie-cruises">Azië</a>
                            </li>
                            <li class="">
                                <a href="/caribbean-midden-amerika-cruises"
                                    >Caribbean &amp; Midden-Amerika</a
                                >
                            </li>
                            <li class="">
                                <a href="/dubai-emiraten-cruises"
                                    >Dubai &amp; Emiraten</a
                                >
                            </li>
                            <li class="">
                                <a href="/middellandsezee-cruises"
                                    >Middellandse Zee</a
                                >
                            </li>
                            <li class="">
                                <a href="/noord-amerika-cruises"
                                    >Noord-Amerika</a
                                >
                            </li>
                            <li class="">
                                <a href="/noord-europa-cruises">Noord-Europa</a>
                            </li>
                            <li class="">
                                <a href="/oceanie-cruises">Oceanie</a>
                            </li>
                            <li class="">
                                <a href="/panamakanaal-cruises">Panamakanaal</a>
                            </li>
                            <li class="">
                                <a href="/transatlantisch-cruises"
                                    >Transatlantisch</a
                                >
                            </li>
                            <li class="">
                                <a href="/wereldcruise-grandvoyages-cruises"
                                    >Wereldcruise &amp; Grand Voyages</a
                                >
                            </li>
                            <li class="">
                                <a href="/westkust-vs-cruises">Westkust VS</a>
                            </li>
                            <li class="">
                                <a href="/zuid-amerika-cruises">Zuid-Amerika</a>
                            </li>
                        </ul>
                    </li>

                    <li class="has-children">
                        <a href="#" v-on:click="subOverigShow = !subOverigShow"
                            >Over Cruisen</a
                        >

                        <ul v-if="subOverigShow">
                            <li
                                class="go-back"
                                v-on:click="subOverigShow = !subOverigShow"
                            >
                                <a href="#0">Terug</a>
                            </li>
                            <li class=""><a href="/vipclub/">VIP Club</a></li>
                            <li class=""><a href="/tv/">CruiseReizen TV</a></li>
                            <li class=""><a href="/blog">Blog</a></li>
                            <li style="display: none;">
                                <a href="#">Waarom cruisen</a>
                            </li>
                            <li class="">
                                <a href="/beginnende-cruiser">Eerste cruise</a>
                            </li>
                            <li style="display: none;">
                                <a href="#">Voorbereiden</a>
                            </li>
                            <li style="display: none;">
                                <a href="#">Fooien</a>
                            </li>
                            <li class="">
                                <a href="/veelgestelde-vragen"
                                    >Veelgestelde vragen</a
                                >
                            </li>
                            <li class="">
                                <a href="/drankenpakket/">Drankenpakket</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'MenuMobile',
    data: function() {
        return {
            subCruisesShow: false,
            subRederijShow: false,
            subBestemmingShow: false,
            subOverigShow: false,
        }
    },
    computed: {
        showMobileMenu: function() {
            return this.$store.state.showMobileMenu
        },
    },
}
</script>

<style scoped></style>
